import { Component } from '@grafikr/components';

export default Component((node) => {
  const selectionInner = node;

  class StickyScroller {
    element: HTMLElement;

    previousY: number;

    initialTop: number;

    currentTop: number;

    constructor(element: HTMLElement) {
      this.element = element;
      this.previousY = window.scrollY;
      this.initialTop = parseFloat(window.getComputedStyle(this.element).top) || 0;
      this.currentTop = 0;

      this.scroll = this.scroll.bind(this);

      window.addEventListener('scroll', this.scroll);
    }

    scroll() {
      const rect = this.element.getBoundingClientRect();
      const topMax = rect.top + window.scrollY - this.element.offsetTop + this.initialTop;
      const topMin = this.element.clientHeight - window.innerHeight;

      if (window.scrollY < this.previousY) {
        this.currentTop -= window.scrollY - this.previousY;
      } else {
        this.currentTop += this.previousY - window.scrollY;
      }

      this.currentTop = Math.min(Math.max(this.currentTop, topMin * -1), topMax, this.initialTop);
      this.previousY = window.scrollY;
      this.element.style.top = `${this.currentTop}px`;
    }

    destroy() {
      window.removeEventListener('scroll', this.scroll);
    }
  }

  new StickyScroller(selectionInner);
});
